var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4217 51.4914V55.39M14.4217 43.6941H16.371M24.1683 43.6941H26.1177M6.62443 14.4542L12.4724 35.8968M53.4082 14.4542L47.5602 35.8968M16.566 10.5556C23.9734 3.14814 36.0592 3.14814 43.4666 10.5556M23.603 16.5322C26.952 13.1833 32.6869 13.1833 36.0397 16.5322M45.6109 51.4914V55.39M29.8214 25.6511C29.5629 25.6511 29.315 25.5484 29.1322 25.3657C28.9494 25.1829 28.8467 24.935 28.8467 24.6765C28.8467 24.418 28.9494 24.1701 29.1322 23.9873C29.315 23.8045 29.5629 23.7018 29.8214 23.7018C30.0799 23.7018 30.3278 23.8045 30.5106 23.9873C30.6933 24.1701 30.796 24.418 30.796 24.6765C30.796 24.935 30.6933 25.1829 30.5106 25.3657C30.3278 25.5484 30.0799 25.6511 29.8214 25.6511ZM5 35.8968H55.0326V51.4914H5V35.8968Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/router.75a303f250ae93c71da054df95603f39.svg";
export { ForwardRef as ReactComponent };